import { useCallback, useState } from 'react';

import { BizyState } from '../../../../../../../components/bizy';
import { useMeetingChat } from '../../../hooks/use-meeting-chat';

export interface ChatMessage {
	role: 'user' | 'assistant';
	content: string;
}

export function useBizyChat(meetingId: string) {
	const [messages, setMessages] = useState<ChatMessage[]>([]);
	const [conversationSummary, setConversationSummary] = useState<string>('');
	const [bizyEmotion, setBizyEmotion] = useState<BizyState>('curious');

	const { mutate, isLoading } = useMeetingChat(meetingId);

	const sendMessage = useCallback(
		(content: string) => {
			// add user message immediately
			setMessages((prev) => [...prev, { role: 'user', content }]);

			mutate(
				{ message: content, conversationSummary },
				{
					onSuccess: (data) => {
						setMessages((prev) => [...prev, { role: 'assistant', content: data.response }]);
						setConversationSummary(data.summary);
						setBizyEmotion(data.emotion as BizyState);
					},
					onError: () => {
						setMessages((prev) => [...prev, { role: 'assistant', content: 'Sorry, I had trouble with that. Could you try again?' }]);
						setBizyEmotion('disappointed');
					},
				}
			);
		},
		[mutate, conversationSummary]
	);

	return {
		messages,
		isLoading,
		bizyEmotion,
		sendMessage,
	};
}
